import { render, staticRenderFns } from "./chatsListContextMenu.vue?vue&type=template&id=3686b89d&"
import script from "./chatsListContextMenu.vue?vue&type=script&lang=ts&"
export * from "./chatsListContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./chatsListContextMenu.vue?vue&type=style&index=0&id=3686b89d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports